// components/widgets/widget-status-dot.js
// ═══════════════════════════════════════════════════════════
// WIDGET STATUS DOT — small animated freshness indicator
// ═══════════════════════════════════════════════════════════
// Renders a small colored dot that signals the widget's current
// data state. Lives next to the widget name in the header.
//
// States:
//   live          — sage, pulse animation (data fresh)
//   stale         — amber, static (data aging)
//   error         — terra, static (fetch failed)
//   regenerating  — gold, spinning opacity (Jarvis working)
//   empty         — steel, static (no data yet)
//   none          — dot hidden entirely
// ═══════════════════════════════════════════════════════════

export default function WidgetStatusDot({ status = 'live', label }) {
  if (!status || status === 'none') return null;

  const ariaLabel = label || `Status: ${status}`;
  return (
    <span
      className={`ws-card-status-dot ws-card-status-${status}`}
      role="status"
      aria-label={ariaLabel}
      title={ariaLabel}
    />
  );
}
